import { LOADER } from '../constants/copy';
// import Contributions from 'articles/contributions';
import Galleries from 'articles/galleries';
import Lightbox from 'articles/lightbox';

class Articles {
  constructor(elems) {

    this.elems = elems;

    this.elems.articles = {
      $articles : [].slice.call(document.getElementsByClassName('articles-category'))
    };

    this.elems.articles.$articles.map(($discipline, i) => {
      $discipline.addEventListener('click', (e) => {
        $('.articles-category').removeClass('darkgray');
        e.target.classList.add('darkgray');
        window.history.pushState(null, null, e.target.getAttribute('href'));
      });
    });

    if (document.getElementsByClassName('slick-gallery')) {
      let $galleryEls = $('.slick-gallery');
      this.Galleries = new Galleries($galleryEls);
    }

    if (document.getElementsByClassName('lightbox-trigger')) {
      this.Lightbox = new Lightbox();
    }

    if (document.getElementById('article-show')) {
      // Sub-components
      // this.Contributions  = new Contributions('Contributions', this.elems);
      // Effects
      this.progress = this.initProgressBar();
    }
  }

  initProgressBar() {
    this.elems.$progress = document.getElementById('progress');

    // refreshes progress with each window scroll and resize event fired
    ['scroll', 'resize'].forEach((e) => {
      window.addEventListener(e, (f) => {
        this.progress = this.updateProgressBar();
      });
    });

    return this.updateProgressBar();
  }

  updateProgressBar() {

    let viewHeight    = window.innerHeight;
    let docLength     = document.body.scrollHeight;
    let totalDistance = docLength - viewHeight;
    let scrollTop     = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    let percentage    = (scrollTop / totalDistance) * 100;

    this.elems.$progress.style.width = percentage + '%';

    return {
      $progress: this.elems.$progress,
      docLength: docLength,
      totalDistance: totalDistance,
      scrollTop: scrollTop,
      percentage: percentage
    }
  }
}

export default Articles;



// WEBPACK FOOTER //
// ./app/javascript/articles/index.js